import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { DeclarationOethDto } from "../../../dto/GenApi.iNotPaie.Dto/DeclarationOethDto";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalSaisieEffectifOeth extends Vue {
	public declarationOETH: DeclarationOethDto = {
   	Id: 0,
   	Annee: 0,
   	Etat: 0,
   	AnneeDsnMetadata: 0,
   	BoethExterneMoinsDeCinquanteAns: 0,
   	MoisDsnMetadata: 0,
   	AccordAgree: false,
   	AccueilBoethSurQuatreAns: false,
   	DepenseAccompagnementBoeth: 0,
   	DepenseCompensationHandicap: 0,
   	DepenseDiagnosticEtTravauxBoeth: 0,
   	DepensePartenariatAssociation: 0,
   	BoethExternePlusDeCinquanteAns: 0,
   	DepenseParticipationEvenement: 0,
   	DepenseProfessionnalisation: 0,
   	BoethInterneMoinsDeCinquanteAns: 0,
   	BoethInternePlusDeCinquanteAns: 0,
   	MontantContributionAnneePrecedente: 0,
   	DepenseSousTraitance: 0,
   	EffectifEcap: 0,
   	EffectifTotal: 0,
   	IdSociete: 0,
   	RecoursSousTraitanceSurQuatreAns: false,
   	IdDsnMetadataFk: 0
	};

	public init(item: DeclarationOethDto): void {
   	this.setData(item);
   	this.$forceUpdate();
	}

	private setData(item: DeclarationOethDto): void {
   	this.declarationOETH = { ...item };
	}

	public save(): void {
   	this.declarationOETH.EffectifTotal = Number(this.declarationOETH.EffectifTotal.toString().replace(",", "."));

   	if (this.declarationOETH.EffectifTotal >= 20) {
   		this.$emit("openSaisieOETH", this.declarationOETH);
   		this.close();
   	} else {
   		if (this.declarationOETH.Id == 0) {
   			ServicesFactoryInstance.DeclarationOethService.CreeDeclarationOeth(this.declarationOETH, () => {
   				NotificationServiceInstance.SendSuccess("La saisie a bien été sauvegardé");
   				this.close();
   			});
   		} else {
   			ServicesFactoryInstance.DeclarationOethService.ModifieDeclarationOeth(this.declarationOETH, () => {
   				NotificationServiceInstance.SendSuccess("La saisie a bien été sauvegardé");
   				this.close();
   			});
   		}
   	}
	}

	public close(): void {
   	this.$emit("refresh");
   	$("#modalSaisieEffectifOeth").modal("hide");
	}
}



// WEBPACK FOOTER //
// ./src/components/dsn/modalSaisieEffectifOeth/modalSaisieEffectifOeth.ts